export default __webpack_public_path__ + "static/media/logo.1e90df98.png";